var _style, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upload_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".upload_svg__st5{fill:none;stroke:#f9af17;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 907.4,
    cy: 332.6,
    r: 32.6,
    fill: "#35a4dd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 702.7V35.3M297.1 235.3L512 34.4M726.9 235.3L512 34.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M645.7 332.6h166.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M377.5 332.6H117V986h790.4V419.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default ForwardRef;